import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import { ChangeEvent, FC, useState } from 'react';

import NumberFormatField from 'components/NumberFormatField';

import { DEFAULT_DATE_FORMAT } from 'constants/general';
import { InventoryItem } from 'types/inventory.interface';

import {
  AddBatchButton, BatchCart, BatchCartDetailsBox, BatchCartInputsBox,
} from '../BatchRowsModal/index.styled';

interface BatchRowProps {
  batch: InventoryItem;
  onQtyAddHandler: (batch: InventoryItem, qty: number) => void;
}

export const BatchRow: FC<BatchRowProps> = ({ batch, onQtyAddHandler }) => {
  const [qtyToAdd, setQtyToAdd] = useState('');

  const onQtyToAddChange = (e: ChangeEvent<HTMLInputElement>) => {
    setQtyToAdd(e.target.value);
  };

  const onAddQtyClick = () => {
    onQtyAddHandler(batch, Number(qtyToAdd));
  };

  return (
    <BatchCart>
      <BatchCartDetailsBox flex={1.7}>
        <Typography variant="body3">{`Batch: ${batch.batchId ?? '-'}`}</Typography>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="body3">{`THC %: ${batch.thc ?? '-'}`}</Typography>
          <Typography variant="body3">{`CBD %: ${batch.cbd ?? '-'}`}</Typography>
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="body3">{`THC mg: ${batch.thcMg ?? '-'}`}</Typography>
          <Typography variant="body3">{`CBD mg: ${batch.cbdMg ?? '-'}`}</Typography>
        </Box>
      </BatchCartDetailsBox>
      <BatchCartDetailsBox flex={1}>
        <Typography variant="body3">{`Available: ${batch.available ?? '-'}`}</Typography>
        <Typography variant="body3">{`Area: ${batch.areaName ?? '-'}`}</Typography>
        <Typography variant="body3">
          {`Expiration: ${batch.expireDate ? format(batch.expireDate, DEFAULT_DATE_FORMAT) : '-'}`}
        </Typography>
      </BatchCartDetailsBox>
      <BatchCartInputsBox flex={1}>
        <NumberFormatField
          value={qtyToAdd}
          size="small"
          onChange={onQtyToAddChange}
          id={`input-itemDetails-${batch.rowItemId}`}
        />
        <AddBatchButton
          id={`button-itemDetails-${batch.rowItemId}`}
          size="small"
          fullWidth
          onClick={onAddQtyClick}
        >
          Add
        </AddBatchButton>
      </BatchCartInputsBox>
    </BatchCart>
  );
};
